var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar3 = function SvgStar3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.673 2.168a.75.75 0 0 0-1.345 0L8.412 8.075l-6.52.953a.75.75 0 0 0-.415 1.28l4.717 4.594-1.113 6.491a.75.75 0 0 0 1.088.79L12 19.118l5.83 3.067a.75.75 0 0 0 1.09-.79l-1.114-6.492 4.717-4.595a.75.75 0 0 0-.415-1.28l-6.52-.952zm-3.09 6.924L12 4.194l2.418 4.898a.75.75 0 0 0 .564.41l5.407.79-1.24 1.208H4.85l-1.24-1.207 5.407-.79a.75.75 0 0 0 .565-.411m-2.06 5.01.002.002zm8.738.665z",
    clipRule: "evenodd"
  })));
};
export default SvgStar3;